<div class="change-ubication">
      <form [formGroup]="formUbication">
            <div class="form-group">
                  <div class="zoneType-selector">
                        <app-dropdown-selector
                              [items]="zoneTypes"
                              [label]="'ubication' | lang"
                              [placeholder]="'select-ubication' | lang"
                              bindLabel="treeName"
                              bindValue="zoneTypeId"
                              [clearable]= "false"
                              [searchable] = "false"
                              [requiredField]="true"
                              formControlName="zoneTypes">
                        </app-dropdown-selector>
                  </div>
                  <div class="date-ubication">
                        <label class="mt-label">
                              {{ 'date-n-hour' | lang }} <span class="required-symbol">*</span>
                        </label>
                        <app-datepicker class="date-ubication"
                              [startSelectedDate]="startDate"
                              (selectedDateEvent)="changeStartDate($event)"></app-datepicker>

                  </div>
                  <div class="hour">
                        <ngb-timepicker
                        [(ngModel)]="time"
                        [size]="'small'"
                        formControlName="time"
                        disabled="disabledTime"></ngb-timepicker>
                        <span class="message-hour"
                        *ngIf="formUbication.errors?.errorHour || formUbication.errors?.errorMinute">
                              <img appImageSelector alt="mt-image" imageKey="alert" imageType="icon" alt="alert-icon"> 
                             {{ 'hour-not-allowed' | lang }}
                        </span>
                  </div>
            </div>
            <div class="float-left mandatory-container">
                  <label class="asterisk">*</label>&nbsp;<label class="mandatory">{{ 'mandatory fields' | lang
                        }}</label>
            </div>
            <div class="float-right buttons-container">
                  <div class="imageCheck" *ngIf="message">
                        <label><img appImageSelector alt="mt-image" imageType="icon" imageKey="check-green"> {{ message }} </label>
                  </div>

                  <div class="flex-row">
                        <app-button text="cancel" class="cancel rounded shadowed" (clickHandler)="clear()"></app-button>
                        <app-button text="change ubication" class="action rounded shadowed" className="auto-width" [disabled]="!formUbication.valid || disableChangeUbication" (clickHandler)="updateUbication()">
                        </app-button>
                  </div>
            </div>
      </form>
</div>
